import { CellComponentProps } from '@melements/front-components/dist/components/list/table/body/cell/Cell.types';
import { LocaleContext, NotificationsContext, NotificationTypes } from '@melements/front-components/dist/context';
import React, { useContext } from 'react';
import { Button } from 'shared';

import { getErrorMessage } from '../../../../../utils/getErrorMessage/getErrorMessage';
import { ActionButtonWrapper } from '../../../Dashboard.styles';

import { DownloadButtonProps } from './DownloadButton.types';

export const DownloadButton = ({
  value: callback,
  onDownloadReport,
  data,
}: CellComponentProps<any> & DownloadButtonProps) => {
  const notificationsContext = useContext(NotificationsContext);
  const localeContext = useContext(LocaleContext);

  const handleReportDownload = () => {
    onDownloadReport(data.fileName)
      .then(results => {
        if (results.error) {
          showNotificationError(results.error);
        } else {
          showNotificationSuccess();
          callback();
        }
      })
      .catch(error => {
        showNotificationError(error);
      });
  };

  const showNotificationSuccess = () => {
    notificationsContext.showNotification({
      message: localeContext.formatMessage({ id: 'REPORTS.TABLE.ACTION.DOWNLOAD-SUCCESS' }),
      time: 3000,
      type: NotificationTypes.SUCCESS,
    });
  };

  const showNotificationError = (error: any) => {
    notificationsContext.showNotification({
      message: getErrorMessage(error, localeContext),
      time: 0,
      type: NotificationTypes.ERROR,
    });
  };

  return (
    <ActionButtonWrapper>
      <Button className="button--action" onClick={handleReportDownload} type={'leading'}>
        {localeContext.formatMessage({ id: 'REPORTS.TABLE.ACTION.DOWNLOAD' })}
      </Button>
    </ActionButtonWrapper>
  );
};
